module.exports = __webpack_public_path__ + "img/no-image.8fe588f0.png";